/*
 * @Author: Jhonsem
 * @Date: 2019-01-02 15:37:37
 * @Last Modified by: Jhonsem
 * @Last Modified time: 2019-01-02 17:05:42
 */
import _Vue from "vue";
import SvgIcon from "@/components/iconSvg/IconSvg.vue";

// This exports the plugin object.
export const SvgIconPlugin = {
  install(Vue: typeof _Vue, options: any) {
    Vue.component("SvgIcon", SvgIcon);
  }
};

// export const requireSvgIconPlugin = () => {
//   //require filpath
//   //directory：说明需要检索的目录
//   // useSubdirectories：是否检索子目录
//   // regExp: 匹配文件的正则表达
//   const resolveFilePath: string = "@/assets/svg-file/golden_followers_tip";
//   console.log("requireSvgIconPlugin resolveFilePath:", require);
//   const req = require.context(
//     "@/assets/svg-file/golden_followers_tip",
//     false,
//     /\.svg$/
//   );
//   console.log("req:", req);
//   const requireAll = (requireContext: any) => {
//     return requireContext.keys().map(requireContext);
//   };
//   requireAll(req);
// };
